<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      entity-name="促销规则"
      :model="model"
      :use-default-action="false"
      :custom-on-row-click="showDetail"
      :use-select="false"
      :use-custom-action="true"
      icon="mdi-clipboard-list"
    >
      <template #primaryButton>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="openPromotionForm"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ $t('add') }}
        </v-btn>
      </template>
      <template
        #item.operation="{item}"
      >
        <v-btn
          icon
          v-if="item.deletedAt"
          small
          @click.stop="restorePromotion(item)"
        >
          <v-icon>
            mdi-restore
          </v-icon>
        </v-btn>
      </template>
      <template
        #item.statusDisplay="{item}"
      >
        <v-chip
          :color="item.deletedAt ? 'error' : 'success'"
          small
        >
          <span>{{ item.status }}</span>
        </v-chip>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showPromotionDialog"
      max-width="900px"
      content-class="promotion-dialog"
    >
      <v-card class="pa-6 rounded-lg">
        <div class="d-flex align-center justify-space-between mb-4">
          <page-sub-header class="primary--text text-h5 font-weight-bold">
            优惠规则
          </page-sub-header>
          <v-btn
            @click="showPromotionDialog = false"
            icon
            color="grey lighten-1"
            class="ml-2"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider class="mb-4" />

        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          color="primary"
          grow
          class="mb-4 promotion-tabs"
        >
          <v-tab class="text-subtitle-1 px-6">
            <v-icon left>
              mdi-information-outline
            </v-icon>
            基础信息
          </v-tab>
          <v-tab class="text-subtitle-1 px-6">
            <v-icon left>
              mdi-filter-outline
            </v-icon>
            规则条件
          </v-tab>
          <v-tab class="text-subtitle-1 px-6">
            <v-icon left>
              mdi-lightning-bolt-outline
            </v-icon>
            动作详情
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card
              elevation="1"
              class="pa-6 rounded-lg"
              color="grey lighten-5"
            >
              <div class="basic-info-container">
                <div class="mb-4">
                  <div class="grey--text text--darken-1 mb-2">
                    规则名称:
                  </div>
                  <v-text-field
                    v-model="ruleName"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    style="width: 100%"
                  />
                </div>

                <div class="mb-4">
                  <div class="grey--text text--darken-1 mb-2">
                    是否激活:
                  </div>
                  <v-select
                    v-model="isActive"
                    :items="activationOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    style="width: 100%"
                  />
                </div>
              </div>
            </v-card>
          </v-tab-item>
          <!-- 规则条件 Tab -->
          <v-tab-item>
            <v-card
              elevation="1"
              class="pa-6 rounded-lg"
              color="grey lighten-5"
            >
              <v-card
                v-for="(type, index) in selectedPromotionTypes"
                :key="index"
                elevation="2"
                class="mt-4 pa-4 rounded-lg promotion-condition-card"
                outlined
              >
                <div class="d-flex align-center mb-2">
                  <div class="condition-number primary--text font-weight-bold mr-3">
                    {{ index + 1 }}
                  </div>
                  <v-select
                    v-model="selectedPromotionTypes[index]"
                    :items="promotionTypeList"
                    item-text="label"
                    item-value="value"
                    label="选择条件类型"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    style="width: 60%"
                  />
                  <v-spacer />
                  <v-btn
                    @click="deletePromotionCondition(index)"
                    icon
                    color="grey darken-1"
                    small
                    class="ml-2"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-divider class="my-3" />

                <template
                  v-if="selectedPromotionTypes[index] === 'TIME_RANGE'"
                >
                  <div class="time-range-container pa-2">
                    <div
                      v-for="(item,timeIndex) in defaultTimeRange.timeRanges"
                      :key="timeIndex"
                      class="time-range-item pa-2 mb-3"
                    >
                      <div class="d-flex align-center">
                        <div class="time-range-label grey--text text--darken-1 mr-2">
                          时间段 {{ timeIndex + 1 }}:
                        </div>
                        <time-selector
                          v-model="item[0]"
                          class="mr-3"
                          :dense="true"
                          label="开始时间"
                          hide-details
                          style="width: 180px"
                        />
                        <div class="mx-2 grey--text">
                          至
                        </div>
                        <time-selector
                          v-model="item[1]"
                          class="mr-3"
                          :dense="true"
                          label="结束时间"
                          hide-details
                          style="width: 180px"
                        />
                        <v-btn
                          small
                          color="error"
                          icon
                          class="ml-1"
                          v-if="defaultTimeRange.timeRanges.length > 1"
                          @click="deleteTimeRange(timeIndex)"
                        >
                          <v-icon small>
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div class="d-flex justify-end mt-2">
                      <v-btn
                        small
                        color="primary"
                        outlined
                        @click="addNewTimeRange()"
                        class="add-time-btn"
                      >
                        <v-icon
                          left
                          small
                        >
                          mdi-plus
                        </v-icon>
                        添加时间段
                      </v-btn>
                    </div>
                  </div>
                </template>
                <template v-if="selectedPromotionTypes[index] === 'DATE_RANGE'">
                  <div class="date-range-container pa-2">
                    <div class="date-range-label grey--text text--darken-1 mb-2">
                      选择日期范围:
                    </div>
                    <date-picker-input
                      v-model="dateRange"
                      card-class="pa-3"
                      :show-tag="false"
                      :need-max="false"
                      color="grey lighten-4"
                      elevation="0"
                    />
                  </div>
                </template>
                <template v-if="selectedPromotionTypes[index] === 'DAY_OF_WEEK'">
                  <div class="day-of-week-container pa-2">
                    <div class="day-of-week-label grey--text text--darken-1 mb-2">
                      选择星期:
                    </div>
                    <v-select
                      v-model="defaultDaysOfWeeks"
                      :items="dayOfWeekDisplay"
                      item-text="label"
                      item-value="value"
                      label="选择星期几"
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      hide-details
                      class="mr-2"
                      style="width: 100%"
                    />
                  </div>
                </template>
                <template v-if="selectedPromotionTypes[index] === 'DISH_CODE'">
                  <div class="dish-code-container pa-2">
                    <div class="dish-code-label grey--text text--darken-1 mb-2">
                      选择菜品:
                    </div>
                    <v-select
                      v-model="defaultDishes"
                      label="选择菜品"
                      :items="allDishList"
                      item-value="code"
                      item-text="dishName"
                      multiple
                      chips
                      small-chips
                      outlined
                      dense
                      hide-details
                      class="mr-2"
                      style="width: 100%"
                    />
                  </div>
                </template>
                <template v-if="selectedPromotionTypes[index] === 'CATEGORY_DE_NAME'">
                  <div class="category-container pa-2">
                    <div class="category-label grey--text text--darken-1 mb-2">
                      选择分类:
                    </div>
                    <v-select
                      v-model="defaultCategory"
                      label="选择分类"
                      multiple
                      chips
                      small-chips
                      item-value="langDE"
                      item-text="_langsname"
                      :items="allCategories"
                      outlined
                      dense
                      hide-details
                      class="mr-2"
                      style="width: 100%"
                    />
                  </div>
                </template>
                <template v-if="selectedPromotionTypes[index] === 'MINIMUM_PURCHASE'">
                  <div class="min-purchase-container pa-2">
                    <div class="min-purchase-label grey--text text--darken-1 mb-2">
                      最低消费金额:
                    </div>
                    <v-text-field
                      v-model="defaultMinPrice"
                      label="输入金额"
                      outlined
                      dense
                      type="number"
                      hide-details
                      prefix="€"
                      class="mr-2"
                      step="0.01"
                      style="width: 60%"
                    />
                  </div>
                </template>
              </v-card>

              <div class="d-flex justify-center mt-4">
                <v-btn
                  color="primary"
                  outlined
                  rounded
                  @click="addPromotionCondition"
                  class="px-6"
                >
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  添加条件
                </v-btn>
              </div>
            </v-card>
          </v-tab-item>

          <!-- 动作详情 Tab -->
          <v-tab-item>
            <v-card
              elevation="1"
              class="pa-6 rounded-lg"
              color="grey lighten-5"
            >
              <v-card
                v-for="(type, index) in selectedActionTypes"
                :key="index"
                elevation="2"
                class="mt-4 pa-4 rounded-lg promotion-action-card"
                outlined
              >
                <div class="d-flex align-center mb-2">
                  <div class="action-number primary--text font-weight-bold mr-3">
                    {{ index + 1 }}
                  </div>
                  <v-select
                    v-model="selectedActionTypes[index]"
                    :items="promotionActionList"
                    item-text="label"
                    item-value="value"
                    label="选择动作类型"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    style="width: 60%"
                  />
                  <v-spacer />
                  <v-btn
                    @click="deleteActionDetail(index)"
                    icon
                    color="grey darken-1"
                    small
                    class="ml-2"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-divider class="my-3" />

                <template v-if="selectedActionTypes[index] === 'FIXED_AMOUNT_DISCOUNT'">
                  <div class="fixed-amount-container pa-2">
                    <div class="fixed-amount-label grey--text text--darken-1 mb-2">
                      固定金额折扣:
                    </div>
                    <v-text-field
                      v-model="defaultAmount"
                      label="输入折扣金额"
                      outlined
                      dense
                      type="number"
                      hide-details
                      prefix="€"
                      class="mr-2"
                      step="0.01"
                      style="width: 60%"
                    />
                  </div>
                </template>

                <template v-if="selectedActionTypes[index] === 'PERCENTAGE_DISCOUNT'">
                  <div class="percentage-container pa-2">
                    <div class="percentage-label grey--text text--darken-1 mb-2">
                      百分比折扣:
                    </div>
                    <v-text-field
                      v-model="defaultPercentage"
                      label="输入折扣百分比"
                      outlined
                      dense
                      type="number"
                      hide-details
                      suffix="%"
                      class="mr-2"
                      step="0.01"
                      style="width: 60%"
                    />
                  </div>
                </template>

                <template v-if="selectedActionTypes[index] === 'SET_PRICE'">
                  <div class="set-price-container pa-2">
                    <div class="set-price-label grey--text text--darken-1 mb-2">
                      设置特定价格:
                    </div>
                    <v-text-field
                      v-model="specialPrice"
                      label="输入特定价格"
                      outlined
                      dense
                      type="number"
                      hide-details
                      prefix="€"
                      class="mr-2"
                      step="0.01"
                      style="width: 60%"
                    />
                  </div>
                </template>

                <template v-if="selectedActionTypes[index] === 'FREE_UPGRADE'">
                  <div class="free-upgrade-container pa-2">
                    <div class="free-upgrade-label grey--text text--darken-1 mb-2">
                      免费升级菜品:
                    </div>
                    <v-select
                      v-model="targetDishCode"
                      label="选择目标菜品"
                      :items="allDishList"
                      item-value="code"
                      item-text="dishName"
                      outlined
                      dense
                      hide-details
                      class="mr-2"
                      style="width: 100%"
                    />
                  </div>
                </template>

                <template v-if="selectedActionTypes[index] === 'TERMINAL_PROMPT'">
                  <div class="terminal-prompt-container pa-2">
                    <div class="terminal-prompt-label grey--text text--darken-1 mb-2">
                      终端提示设置:
                    </div>

                    <v-text-field
                      v-model="terminalPromptData.title"
                      label="提示标题"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      style="width: 70%"
                    />

                    <v-textarea
                      v-model="terminalPromptData.content"
                      label="提示内容"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      style="width: 100%"
                      rows="3"
                    />

                    <div class="image-upload-section mb-2">
                      <div class="image-upload-label grey--text text--darken-1 mb-2">
                        上传图片:
                      </div>
                      <div class="d-flex flex-wrap align-center">
                        <v-card
                          width="80"
                          height="80"
                          class="mr-3 mb-3 upload-card"
                          color="grey lighten-4"
                          elevation="0"
                          outlined
                          @click="$refs.file.$refs.input.click()"
                        >
                          <v-icon
                            color="grey darken-1"
                            class="upload-icon"
                            style="position: absolute;right: 0;bottom: 0;top: 0;left: 0;margin: auto"
                          >
                            mdi-plus
                          </v-icon>
                        </v-card>

                        <template v-if="usePic.length > 0">
                          <div
                            v-for="(img,imgIndex) in usePic"
                            :key="imgIndex"
                            class="mr-3 mb-3 position-relative"
                          >
                            <v-img
                              width="80"
                              height="80"
                              :src="img"
                              class="rounded-lg"
                            />
                            <v-btn
                              x-small
                              icon
                              color="error"
                              class="image-delete-btn"
                              style="position: absolute; top: -8px; right: -8px; background: white;"
                              @click="removeImage(imgIndex)"
                            >
                              <v-icon x-small>
                                mdi-close
                              </v-icon>
                            </v-btn>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </v-card>

              <div class="d-flex justify-center mt-4">
                <v-btn
                  color="primary"
                  outlined
                  rounded
                  @click="addActionDetail"
                  class="px-6"
                >
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  添加动作
                </v-btn>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <div class="d-flex justify-end mt-6">
          <v-btn
            text
            class="mr-4"
            @click="showPromotionDialog = false"
          >
            取消
          </v-btn>
          <v-btn
            color="primary"
            elevation="2"
            rounded
            class="px-6"
            @click="savePromotion"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            保存
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-file-input
      ref="file"
      accept="image/*"
      multiple
      dense
      hide-details
      outlined
      prepend-icon=""
      style="height: 0;opacity: 0"
      @change="processFile"
    />
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import PromotionList, {
  dayOfWeekDisplay,
  promotionTypeList,
  promotionActionList,
  savePromotionData, restorePromotion
} from '@/model/dataLayer/api/promotion/PromotionList'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'
import TimeSelector from '@/views/AadenPages/settings/reserveSetting/openTime/TimeSelector.vue'
import DatePickerInput from '@/views/AadenPages/dashboard/components/DatePickerInput.vue'
import { defaultDate } from '@/model/dataLayer/api/common/DateRepository'
import Dish from '@/model/dataLayer/api/dish/Dish'
import Category from '@/model/dataLayer/api/dish/Category'
import { saveFilesWithArr } from '@/model/dataLayer/api/newReservation/reservationTable'
import i18n from '@/i18n'

export default {
  components: {
    DatePickerInput,
    TimeSelector,
    PageSubHeader,
    IkDataTable
  },
  data: function () {
    return ({
      withDeleted: false,
      activeTab: 0,
      defaultTimeRange: {
        type: 'TIME_RANGE',
        timeRanges: [['', '']]
      },
      defaultDateRange: {
        type: 'DATE_RANGE',
        start: '',
        end: '',
        startInclusive: true,
        endInclusive: true
      },
      defaultDaysOfWeeks: [],
      defaultDishes: [],
      defaultCategory: [],
      defaultMinPrice: '',
      dateRange: [defaultDate, defaultDate],
      showPromotionDialog: false,
      model: PromotionList,
      promotionTypeList,
      selectedPromotionTypes: [''],
      promotionActionList,
      selectedActionTypes: [''],
      actionValues: [''],
      terminalPromptData: { title: '', content: '', image: null },
      dayOfWeekDisplay,
      usePic: [],
      imgFiles: null,
      allDishList: [],
      allCategories: [],
      defaultAmount: 0,
      defaultPercentage: 0,
      specialPrice: 0,
      targetDishCode: '',
      ruleName: '',
      isActive: false,
      activationOptions: [
        { text: i18n.t('yes'), value: true },
        { text: i18n.t('no'), value: false }
      ],
      editRule: null

    })
  },
  computed: {
    realFilter () {
      return {
        withDeleted: this.withDeleted
      }
    }
  },
  async mounted () {
    this.allDishList = await Dish.getList(true)
    this.allCategories = (await Category.getList(true)).map(it => {
      it.langDE = it.langs.find(it => it.lang === 'DE')?.name
      return it
    })
  },
  methods: {
    async restorePromotion (item) {
      await restorePromotion(item.id)
      await this.$refs.table.reload()
    },
    async showDetail (item) {
      this.resetForm()
      this.editRule = item
      // Set rule name and active status
      this.ruleName = item.ruleName || ''
      this.isActive = item.isActive

      // Parse predicates and actions from JSON strings
      const predicates = JSON.parse(item.predicates || '[]')
      const actions = JSON.parse(item.actions || '[]')

      // Process predicates
      for (const predicate of predicates) {
        if (predicate.type === 'TIME_RANGE') {
          this.selectedPromotionTypes.push('TIME_RANGE')
          this.defaultTimeRange = predicate
        } else if (predicate.type === 'DATE_RANGE') {
          this.selectedPromotionTypes.push('DATE_RANGE')
          this.dateRange = [predicate.start, predicate.end]
        } else if (predicate.type === 'DAY_OF_WEEK') {
          this.selectedPromotionTypes.push('DAY_OF_WEEK')
          this.defaultDaysOfWeeks = predicate.days || []
        } else if (predicate.type === 'DISH_CODE') {
          this.selectedPromotionTypes.push('DISH_CODE')
          this.defaultDishes = predicate.dishCodes || []
        } else if (predicate.type === 'CATEGORY_DE_NAME') {
          this.selectedPromotionTypes.push('CATEGORY_DE_NAME')
          this.defaultCategory = predicate.categoryNames || []
        } else if (predicate.type === 'MINIMUM_PURCHASE') {
          this.selectedPromotionTypes.push('MINIMUM_PURCHASE')
          this.defaultMinPrice = predicate.amount || 0
        }
      }

      // Remove the initial empty item if we added any predicates
      if (this.selectedPromotionTypes.length > 1) {
        this.selectedPromotionTypes.shift()
      }

      // Process actions
      for (const action of actions) {
        if (action.type === 'FIXED_AMOUNT_DISCOUNT') {
          this.selectedActionTypes.push('FIXED_AMOUNT_DISCOUNT')
          this.defaultAmount = action.amount || 0
        } else if (action.type === 'PERCENTAGE_DISCOUNT') {
          this.selectedActionTypes.push('PERCENTAGE_DISCOUNT')
          this.defaultPercentage = action.percentage || 0
        } else if (action.type === 'SET_PRICE') {
          this.selectedActionTypes.push('SET_PRICE')
          this.specialPrice = action.price || 0
        } else if (action.type === 'FREE_UPGRADE') {
          this.selectedActionTypes.push('FREE_UPGRADE')
          this.targetDishCode = action.targetDishCode || ''
        } else if (action.type === 'TERMINAL_PROMPT') {
          this.selectedActionTypes.push('TERMINAL_PROMPT')
          this.terminalPromptData.title = action.title || ''
          this.terminalPromptData.content = action.content || ''

          // Handle image URLs if available
          this.usePic = action.imageUrls || []
        }
      }

      // Remove the initial empty item if we added any actions
      if (this.selectedActionTypes.length > 1) {
        this.selectedActionTypes.shift()
      }

      // Open the dialog
      this.showPromotionDialog = true
    },

    async deletePromotion (item) {
      await this.model.remove(item.id)
      await this.$refs.table.reload()
    },
    async processFile (event) {
      for (const item of event) {
        this.usePic.push(URL.createObjectURL(item))
      }
      this.imgFiles = event
    },

    removeImage (imgIndex) {
      // Remove the image from the usePic array
      this.usePic.splice(imgIndex, 1)

      // Create a new FileList-like object without the removed file
      if (this.imgFiles && this.imgFiles.length > 0) {
        const dt = new DataTransfer()
        for (let i = 0; i < this.imgFiles.length; i++) {
          if (i !== imgIndex) {
            dt.items.add(this.imgFiles[i])
          }
        }
        this.imgFiles = dt.files
      }
    },
    addNewTimeRange () {
      this.defaultTimeRange.timeRanges.push(['', ''])
    },

    deleteTimeRange (timeIndex) {
      // Don't delete if there's only one time range
      if (this.defaultTimeRange.timeRanges.length <= 1) {
        return
      }

      // Remove the time range at the specified index
      this.defaultTimeRange.timeRanges.splice(timeIndex, 1)
    },

    async openPromotionForm () {
      this.resetForm()
      this.showPromotionDialog = true
    },

    resetForm () {
      this.selectedPromotionTypes = ['']
      this.selectedActionTypes = ['']
      this.actionValues = ['']
      this.terminalPromptData = { title: '', content: '', image: null }
      this.defaultTimeRange.timeRanges = [['', '']]
      this.ruleName = ''
      this.isActive = false
      this.editRule = null
    },

    addPromotionCondition () {
      this.selectedPromotionTypes.push('')
    },

    deletePromotionCondition (index) {
      // Don't delete if there's only one condition
      if (this.selectedPromotionTypes.length <= 1) {
        return
      }

      // Remove the condition at the specified index
      this.selectedPromotionTypes.splice(index, 1)
    },

    addActionDetail () {
      this.selectedActionTypes.push('')
      this.actionValues.push('')
    },

    deleteActionDetail (index) {
      // Don't delete if there's only one action
      if (this.selectedActionTypes.length <= 1) {
        return
      }

      // Remove the action at the specified index
      this.selectedActionTypes.splice(index, 1)
      this.actionValues.splice(index, 1)
    },

    async savePromotion () {
      const predicates = []
      const actions = []

      // Process predicates
      const predicateHandlers = {
        TIME_RANGE: () => ({
          type: 'TIME_RANGE',
          timeRanges: this.defaultTimeRange
        }),
        DATE_RANGE: () => ({
          type: 'DATE_RANGE',
          start: this.dateRange[0],
          end: this.dateRange[1],
          startInclusive: true,
          endInclusive: true
        }),
        DAY_OF_WEEK: () => ({
          type: 'DAY_OF_WEEK',
          days: this.defaultDaysOfWeeks
        }),
        DISH_CODE: () => ({
          type: 'DISH_CODE',
          dishCodes: this.defaultDishes
        }),
        CATEGORY_DE_NAME: () => ({
          type: 'CATEGORY_DE_NAME',
          categoryNames: this.defaultCategory
        }),
        MINIMUM_PURCHASE: () => ({
          type: 'MINIMUM_PURCHASE',
          amount: this.defaultMinPrice
        })
      }

      // Add predicates based on selected types
      for (const type of this.selectedPromotionTypes) {
        if (type && predicateHandlers[type]) {
          predicates.push(predicateHandlers[type]())
        }
      }

      // Process actions
      const actionHandlers = {
        FIXED_AMOUNT_DISCOUNT: () => ({
          type: 'FIXED_AMOUNT_DISCOUNT',
          amount: this.defaultAmount
        }),
        PERCENTAGE_DISCOUNT: () => ({
          type: 'PERCENTAGE_DISCOUNT',
          percentage: this.defaultPercentage
        }),
        SET_PRICE: () => ({
          type: 'SET_PRICE',
          price: this.specialPrice
        }),
        FREE_UPGRADE: () => ({
          type: 'FREE_UPGRADE',
          targetDishCode: this.targetDishCode
        }),
        TERMINAL_PROMPT: async () => {
          const imagesList = await saveFilesWithArr(this.imgFiles) ?? []
          return {
            type: 'TERMINAL_PROMPT',
            title: this.terminalPromptData.title,
            content: this.terminalPromptData.content,
            imageUrls: imagesList
          }
        }
      }

      // Add actions based on selected types
      for (const type of this.selectedActionTypes) {
        if (type && actionHandlers[type]) {
          const actionResult = await actionHandlers[type]()
          if (actionResult) {
            actions.push(actionResult)
          }
        }
      }

      // Save the promotion
      await savePromotionData({
        id: this.editRule?.id ?? null,
        actions: JSON.stringify(actions),
        predicates: JSON.stringify(predicates),
        isActive: this.isActive,
        ruleName: this.ruleName
      })

      this.showPromotionDialog = false
      await this.$refs.table.reload()
    }
  }
}
</script>

<style scoped>
.promotion-dialog {
  border-radius: 12px;
}

.promotion-tabs .v-tab {
  letter-spacing: 0.5px;
  font-weight: 500;
}

.promotion-condition-card, .promotion-action-card {
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.promotion-condition-card:hover, .promotion-action-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.condition-number, .action-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(33, 150, 243, 0.1);
  font-size: 14px;
}

.time-range-item, .date-range-container, .day-of-week-container,
.dish-code-container, .category-container, .min-purchase-container,
.fixed-amount-container, .percentage-container, .set-price-container,
.free-upgrade-container, .terminal-prompt-container {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 12px !important;
}

.upload-card {
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px dashed #bdbdbd;
}

.upload-card:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.image-delete-btn {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.image-delete-btn:hover {
  opacity: 1;
}

.basic-info-container {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 16px;
}
</style>
